/* eslint-disable */
// Call the dataTables jQuery plugin
$(document).ready(function() {
  $('#dataTable').DataTable();
});



// WEBPACK FOOTER //
// ./src/assets/js/demo/datatables-demo.js